import 'babel-polyfill'
import Vue from 'vue'
import md5 from 'js-md5'
import App from './App.vue'
import router from './router/index.js'
import Router from 'vue-router'
import store from './store/index.js'
import mockjs from 'mockjs'
import api from '@/http/api.js'
import request from './http/request.js'
import { http, bizhttp, commonhttp } from './config.js'
import common from './util/common.js'
import CssPage from '@/components/CssPage/index.js'
import specialDesigner from 'special-designer'
import 'special-designer/lib/special-designer.css'
Vue.config.productionTip = false //是阻止显示生产模式的消息
Vue.use(specialDesigner)
Vue.use({
  install: function (Vue) {
    Vue.component('CssPage', CssPage)
  }
})
function init() {
  Vue.prototype.$store = store
  Vue.prototype.$md5 = md5
  const { http: $http, request: $request } = request(http, api)
  Vue.prototype.$http = $http
  Vue.prototype.$request = $request
  initCssUI(Vue, { request: $http })
  LowcodeResolver.initResolver(
    Vue,
    { http: commonhttp },
    { http: bizhttp, router: router, VueRouter: Router }
  )
  //初始化grid字典
  window.Slw.Dict = new Vue().dict
  window.mockjs = mockjs
  //初始化dialog路由实例
  Vue.prototype.router = router
  for (let k in common) {
    window[k] = common[k]
  }
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}
//可修改配置文件异步加载处理
let baseUrl = http.axiosOption.baseURL
if (baseUrl && typeof baseUrl == 'function') {
  baseUrl(function (url) {
    http.axiosOption.baseURL = url
    init()
  })
} else {
  init()
}
